export default {
    setting: {
        language: 'English',
        dialogDetermine: 'Done / OK',
        dreivatives: 'Futures',
        markets: 'Markets',
        assets: 'Assets',
        liquidity: 'Mining',
        helpCentre: 'Support center',
        announcementCenter: 'Announcements',
        about: 'About',
        bulletinCentre: 'Announcements',
        serviceAgreement: 'Service Agreement',
        support: 'Support',
        onlineSupportCustomerService: 'Contact Us',
        suggestionsAndFeedback: 'Suggestions and Feedback',
        service: 'Service',
        download: 'Download',
        coinApplication: 'Listing application',
        privacyStatement: 'Privacy Statement',
        trade: 'Trade',
        standardConteact: 'Perpetual',
        signOut: 'Log out',
        assetWallets: 'Asset Wallets',
        financeRecords: 'Transaction History',
        identification: 'Verification',
        personalCenter: 'Personal center',
        chooseLanguage: 'Choose language',
        tips: 'Tips',
        dark: 'Dark mode',
        light: 'Day mode',
        hosting: "Hosting",
        languageTitle: 'Language',
        convertCurrency: 'Convert currency',
        cancel: 'Cancel',
        aboutUs: 'About Us',
        standard: 'Standard perpetuity',
        share: 'Share With Friends',
        introduce: 'About Us',
        set: 'Settings',
        changePassword: 'Change login password',
        denomination: 'Denomination currency',
        color: 'Color scheme',
        code: 'Version number',
        color1: 'Red up green down',
        color2: 'Green up red down',
        setLangue: 'Language setting',
        vip: 'VIP benefits',
        vip2: 'Current VIP level',
        safeMenu: 'Security',
        conventional: "Conventional",
        other: "Other",
        quickTips: 'Add up to 3 shortcut function buttons',
        quickTransaction: "Quick transaction",
        safeConvenient: "Safe and convenient",
        timeSharing: "Line",
        currentLevel: "Current level",
        levelBenefits: "Level %{level} Benefits",
        teamLevel: "Team level",
        levelLower: "Level %{level} lower",
        rules: "Rules",
        bindWithdrawalAddress: "Bind withdrawal address",
        tipsBindWithdrawalAddress: "You have not bound the withdrawal address yet, please bind it first",
        walletAddressFormatIncorrect: "Wallet address format is incorrect",
        tradeRules1: "Forecast the rise and fall of the future period. The price at the time of placing an order is the initial price, and the price at the last second of the forecast period is the settlement price. If the settlement price is greater than the initial price, it means an increase, and if the settlement price is less than the initial price, it means a decrease.",
        tradeRules2: "1. What is a contract",
        tradeRules3: "This platform provides USDT-based Life-long contracts. Users can choose to buy long or sell short contracts by judging the rise and fall to obtain income from the rise/fall of digital asset prices. Perpetual contracts have no delivery date, and users can hold them forever.",
        tradeRules4: "2. What is margin",
        tradeRules5: "In the virtual contract market, users only need to pay a small amount of funds in a certain quantity according to the contract price as a financial guarantee for the performance of the contract, and then they can participate in the transaction of the contract. This fund is the virtual contract margin.\nThe contract on this platform adopts the different margin mode of sub-account. Each currency corresponds to a contract account, and the account assets and positions of different contract currencies are independent of each other, and the transfer and transaction between different contract accounts do not affect each other. After the user's contract account is opened, the risks and benefits of all positions in the contract account will be calculated together.",
        tradeRules6: "3. How to calculate margin",
        tradeRules7: "Position Margin = Contract Face Value * Number of Position Contracts / Support Multiple\nFreezing margin = the sum of margins of all successful pending order opening orders in the current order\nAvailable Margin = Account Balance - Position Margin - Freeze Margin",
        tradeRules8: "4. How to calculate margin rate",
        tradeRules9: "The margin rate is an indicator to measure the user's asset risk.\nMargin rate = (unrealized profit and loss + position margin + usable margin + frozen margin - closing fee) / position margin\nThe smaller the margin rate, the higher the risk of the account. When the margin rate is less than or equal to 0%, forced repayment will be triggered.",
        tradeRules10: "5. What is the estimated repayment price",
        tradeRules11: "The estimated forced repayment price, that is, the theoretically triggered forced liquidation price calculated by the system, is for reference only and may have a slight different from the actual value.",
        tradeRules12: "6. What is the total rights and unrealized profit and loss of the account",
        tradeRules13: "Total account rights = account balance + unrealized profit and loss\nThe unrealized profit and loss is the profit and loss of the user's current position in the currency contract, and the unrealized profit and loss will change with the latest transaction price changes.\nUnrealized profit and loss of long positions = (1/average position price - 1/latest transaction price) * number of long contracts * contract face value * latest transaction price\nUnrealized profit and loss of short position = (1/latest transaction price - 1/average position price) * number of short contracts * contract face value * latest transaction price",
        text1: "Account Security",
        text2: "Light / Night",
        text3: "Clear cache",
        text4: "Are you sure you want to log out?",
        text5: "Are you sure you want to clear the cache?",
        text6: "Language",
        text7: "To protect your security, it is recommended to enable at least one two-factor authentication"
    },
    login: {
        emailLogin: "Email Login",
        phoneLogin: "Phone Login",
        login: 'Login',
        register: 'Register',
        title1: 'Trade anytime, anywhere and view live quotes',
        title2: 'Trade anytime, anywhere, view real-time market conditions',
        title3: 'The Most Secure Cryptocurrency Trading Platform',
        formTitle1: 'Account Login',
        formTitle2: 'Welcome back! Sign in with your email, phone number',
        btn1: 'Mobile number',
        btn2: 'Email',
        btn3: 'Login',
        btn4: 'Register',
        btn5: 'Forget password?',
        field1: 'Mobile phone number',
        field2: 'Password',
        field3: 'Email',
        placeholder1: 'Country',
        placeholder2: 'Please enter your mobile phone number',
        placeholder3: 'Please enter your password',
        placeholder4: 'Please enter your email address',
        content12: 'Please enter your mobile phone number',
        content13: 'Please enter your password',
        content14: 'Please enter your email address',
        content16: 'Digital Asset Financial Services',
        loginSuccess: 'Login successful ',
        chooseArea: 'Please enter your area code',
        placeholder5: 'Please select country code',
        placeholder6: 'Remember my password',
        placeholder7: 'Download APP',
        placeholder8: 'Contact Customer Service',
        placeholder9: 'Select country or region',
        placeholder10: 'Area',
        placeholder11: 'Wallet login',
        placeholder12: 'Action failed, please switch to ',
        placeholder13: ' wallet'
    },
    aboutUs: {
        aboutCoinbeadCenterTitle: 'About ',
        aboutCoinbeadCenterDetails: "The world’s leading blockchain asset trading platform which creates opportunities globally",
        footDetails1: 'Daily Transaction Volume',
        footDetails2: 'Transactions/Second',
        footDetails3: 'Support center',
        coinbeadCenterTitle: '',
        coinbeadCenterDetails: " It is a world-renowned international site for digital assets, mainly for global users to provide bitcoin (BTC), litecoin (LTC), ethereum (ETH) and other digital assets of coins and derivatives",
        coinbeadCenterDetailsm: " Our vision is to make money flow freely around the globe. We believe that spreading this freedom makes the world a better place",
        infrastructureCenterTitle: 'Infrastructure',
        infrastructureCenterDetails: 'Our mission is to provide infrastructure services for the entire blockchain ecosystem',
        freeCenterTitle: 'Freedom',
        freeCenterDetails: 'Our vision is to make money flow freely around the globe. We believe that spreading this freedom makes the world a better place',
        futureCenterTitle: 'Pioneering the future of technology',
        futureCenterDetails: 'Open up the future of technology',
    },
    applicationForListing: {
        title: 'Application for listing',
        projectName: 'Project Name',
        tokenName: 'Token Name',
        projectDescription: 'Project Description',
        contractAddress: 'Contract Address',
        officialWebsite: 'Official Website',
        ContactAndEmail: 'Contact Email',
        ContactAndName: 'Contact Name',
        file: 'Upload Attachment',
        pleaseEnter: 'Please enter ',
        enterFile: 'Please upload a file',
        upload1: 'The current limit is 1 file selected.',
        upload2: 'This time select',
        upload3: 'files.',
        upload4: 'Total selected',
        upload5: 'Total files selected',
    },
    public: {
        submit: "Submit",
        copySuccessfully: 'Copy Successful',
        copyFailed: 'Copy failure',
        noDate: "No data",
        submitSuccessfully: 'Submitted Successfully',
        goBack: 'Return to previous page',
        cancel: 'Cancel',
        home: 'Home',
        loading: 'loading...',
        confirm: 'Confirm',
        loadingFailed: 'Network anomaly',
        nomore: 'No more',
        tryAgain: 'Please refresh the page/exit the program and re-upload!',
        hot: "Hot",
    },
    inviteFriends: {
        inviteFriends: 'Share With Friends',
        freedomOfWealth: 'Let wealth be free together',
        myInvitationCode: 'My invitation code',
        clickCopy: 'Click copy',
        myInvitationLink: 'My invitation code link',
        clicktoSaveTheQRCode: 'Click save',
        saveQRCode: 'Invitation QR code',
        numberOfSubordinates: 'Team',
        rebateIncome: 'Rebate Revenue',
        people: 'People',
        myPromotionRevenue: 'My promotion revenue',
        numberOfDirectSubordinates: 'Direct Subor',
        totalNumberOfSubordinates: 'Total Subor',
        directSubordinateReturnsCommission: 'Direct Subor Gains',
        theTotalCommission: 'Total Revenue',
        checkHistory: 'Earnings Record',
        history: 'Earnings Record',
        theLowerAccount: 'Subordinate Account',
        type: 'Type:',
        serviceCharge: 'Handling Fee:',
        percentageofCommissionReturned: 'Rebate Percentage:',
        commissionrebateAmount: 'Rebate Amount:',
        time: 'Time',
        typeName1: 'Recharge rebate',
        typeName2: 'Tertiary Distribution of MT order handling fee',
        typeName3: 'MT profitable Tertiary Distribution',
        typeName4: 'Referral reward',
        typeName30: 'Recharge rebate',
        typeName31: 'Periodic trading profit rebate',
        typeName32: 'Mining profit rebate',
        typeName45: 'Transaction fee rebate',
        typeName46: 'Own handling fee rebate',
        typeName50: 'Trade handling fee rebate',
        typeName51: 'Perpetual handling fee rebate',
        typeName52: 'Additional rebate for Trade contract handling fees',
        typeName53: 'Additional rebate for perpetual contract fees',
        typeName54: 'Additional rebates for perpetual contract fees',
        shareRules1: "Invitation Description",
        shareRules2: "Enter the 'Invitation Center', copy the invitation link or code, and share it with your friends. Friends can become your subordinates by registering with your invitation code.",
        shareRules3: "Earn rebates",
        shareRules4: "When subordinates conduct transactions, you can get corresponding rebates, which support up to three subordinates. For example, if you invite friend A, A invites B, and B invites C, then A, B, and C are in You can get corresponding rebates for transactions such as contracts on the platform.",
        shareRules5: "Team Level",
        shareRules6: "The more one-level subordinates are promoted, the higher the team level, the higher the rebate you can enjoy. The team level is divided into LV1-LV6, and the upgrade rules are shown in the table below, where 'N' means that you have recharged and completed the real-name authentication. The number of subordinates.",
        shareRules7: "You can get a commission corresponding to the betting amount of the subordinates who bet on the delivery contract.",
        upgradeConditions: "Require",
        recommendedNumberOfPeople: "Recommended number of people"
    },
    suggestionsAndFeedback: {
        suggestionsAndFeedback: 'Suggestions and Feedback',
        text: 'Feedbacks are welcome if you encounter bugs or have product suggestions while using.',
        email: 'Email address',
        enterEmail: 'Please enter email address',
        enterCorrectEmail: 'Please input the correct email address',
        title: 'Title',
        enterTitle: 'Please enter question title',
        describeTheProblem: 'Describe the problem',
        enterDescribeTheProblem: 'Please enter the problem you describe',
        submit: 'Submit',
    },
    help: {
        enterSearch: 'Search',
        title: 'Support center',
        search: "Search"
    },
    announcement: {
        enterSearch: 'Search',
        title: 'Announcements',
        search: "Search"
    },
    privacy: {
        title: 'Privacy Statement',
        content1: "1. What personal information is collected from users?",
        content2: "Personal information is collected in order to provide products and services and to continuously improve them.",
        content3: "The following are the types of personal information we collect.",
        content4: 'Information you provide to us: We receive and store any information that you provide in connection with the Platform. You may choose not to provide certain information, but may not be able to use certain Platform Services as a result. Examples of information you provide to us include.',
        content5: "Name",
        content6: "Address",
        content7: "Nationality",
        content8: "Photo ID",
        content9: "Mobile Phone Number / Email Number",
        content10: "Other information that helps us to identify you",
        content11: 'Automatically Collected Information: We automatically collect and store certain types of information about your use of the Platform Services and, like many websites, we use cookies and other unique identifiers. When your web browser or device accesses the Platform, we obtain certain types of information. Examples of the information we collect and analyse include.',
        content12: "The Internet Protocol (IP) address that connects the personal computer to the Internet.",
        content13: "The login information, e-mail address, password and location of the personal device or computer.",
        content14: "Version and time zone settings.",
        content15: "Transaction history.",
        content16: "Information from other sources: We may collect information about you from other sources, such as credit history from credit bureaus. We will use this information to prevent and detect fraud.",
        content17: "2. Can children use it?",
        content18: 'The Platform does not allow any individual under the age of 18 to use the Services.',
        content19: "3. What are cookies and other identifiers used for?",
        content20: "We use cookies and similar tools to optimise the user experience, to deliver our services and to understand how our customers use our services in order to make targeted improvements. We use cookies to ensure that our systems can recognise your browser or device and provide services to you.",
        content21: 'We use operational cookies and similar tools (collectively "Cookies") to provide services such as.',
        content22: "To identify you when you log in and use our services.",
        content23: "To provide customised features and services.",
        content24: "To protect against fraudulent activity.",
        content25: "To improve security.",
        content26: "Track your preferences (e.g. currency and language).",
        content27: "We also use cookies to understand how users use our services in order to make targeted improvements.",
        content28: "4. Will my personal information be shared?",
        content29: "User information is an important part of our business and we do not sell personal information about our users to others. The Platform will only share users' personal information with its subsidiaries or affiliates who comply with this Privacy Statement or who follow practices that are at least as protective as the protections described in this Privacy Statement in the circumstances described below.",
        content30: "Third party service providers: We employ other companies and individuals to perform functions on our behalf. Examples of such functions include: analysing data, providing marketing assistance, processing payments, transmitting content and assessing and managing credit risk. These third party service providers have access to the personal information needed to perform their functions, but may not use it for other purposes. In addition, they must handle personal information in accordance with this privacy statement and the corresponding data protection laws.",
        content31: "Business Transfers: As our business continues to grow, we may sell or purchase other businesses or services. In such transactions, user information is generally part of the transferred business assets, but remains subject to the commitments in any pre-existing privacy statements (unless, of course, the user agrees otherwise). In addition, if the Company or substantially all of its assets are acquired, user information will also be transferred. Protection of the Division and others: We will release account and other personal information as described when we believe release is appropriate to comply with the law or our regulatory obligations, to enforce or apply our Terms of Use and other agreements, or the rights, property or safety of users or others. This includes exchanging information with other companies and organizations to prevent fraud and reduce credit risk. ",
        content32: "5. International transfers of personal data",
        content33: 'The Division may transfer your data outside the European Economic Area ("EEA"). The Division will take appropriate safeguards to ensure that such transfers comply with the applicable data protection rules, unless the European Commission has confirmed that the country/region receiving the transferred data can provide an adequate level of protection. ',
        content34: "6. Is my personal information secure?",
        content35: "We have designed our systems with your security and privacy in mind. We use encryption protocols and software in an effort to keep personal information secure during transmission.",
        content36: "We always implement physical safeguards, electronic safeguards and procedural safeguards in relation to the collection, storage and disclosure of personal information. Our security procedures mean that we may need to verify your identity before disclosing personal information to you.",
        content37: "There is nothing more important to you than to protect your personal account password from unauthorised access. We recommend setting a unique password for your account that distinguishes it from other online accounts. And always log out after using a shared computer. ",
        content38: "7. How do I protect my personal information?",
        content39: "If you have any questions or objections to the way we collect and process personal information, please contact our customer service team",
        content40: "After you have given your consent for us to process your personal data for a specific purpose, you can withdraw your intention at any time and we will stop processing your data for that purpose.",
        content41: "In addition, you have the right to request access to, rectification and deletion of personal data and to request the transfer of data, subject to the appropriate legislation. You may also object to our processing of your personal data or request that we restrict our processing of your personal data in certain circumstances. ",
        content42: "8. EU GDPR and UK data protection law - the legal basis",
        content43: "The EU GDPR and UK data protection laws require us to follow the legal basis for the use of personal information. Our bases depend on the specific purposes for which personal information is used. These bases include.",
        content44: "Fulfilment of contracts - to provide products or services to you or communicate with you about them, including our use of your personal information to accept and process orders and to process payments.",
        content45: "Our legitimate business interests and the interests of our users - we detect and prevent fraud and abuse and provide protection for the safety of our users, ourselves or others. ",
        content46: "Your consent - We need your consent to process your personal information for the specific purpose for which it was communicated to you. Once you have given your consent for us to process your personal information for a specific purpose, you can withdraw your intention at any time and we will stop processing your data for that purpose. ",
        content47: "Compliance with legal obligations-We use your personal information as required by law. For example, we collect bank account information for identity verification purposes.",
        content48: "The above and other legal bases depend on the specific purposes for which we use personal information.",
        content49: "9. conditions of use, notices and amendments",
        content50: "Your use and any dispute over privacy is subject to this statement and our terms of use. If you have any concerns about the privacy of this platform, please contact us with a detailed explanation and we will be happy to help you resolve them. You also have the right to contact your local data protection authority. ",
        content51: "Our business is constantly changing and our privacy statement will change with it. You should check our website frequently for the latest changes. If you do not agree with the revisions, you should stop visiting immediately. By continuing to access the updated Privacy Policy after it is posted, you agree with the updates and agree to abide by the updated Privacy Policy. Unless otherwise stated, the current privacy statement applies to all information we hold about you and your account. ",
    },
    serviceAgreement: {
        title: 'Service Agreement',
        content1: 'The Site is a platform for users to trade in digital assets and provide related services ("Service" or "Services"). For the convenience of this Agreement, the Site is collectively referred to in this Agreement as "we" or other first-person designations. As long as the natural person or other entity accessing the Site is a user of the Site, for the purposes of this Agreement, "you" or other second person is used below. For the purposes of this Agreement, we and you are collectively referred to in this Agreement as the "Parties" and we or you are referred to solely as a "Party".',
        content2: "Important Note:",
        content3: "We would like to remind you in particular that",
        content4: "1 The digital assets themselves are not issued by any financial institution or company or by this website",
        content5: "2 the market for digital assets is new, unrecognised and likely not to grow.",
        content6: "3 digital assets are used heavily mainly by speculators, with relatively little use in the retail and commercial markets, and there is an extremely high risk associated with trading in digital assets, which are traded around the clock, have no limits on rise or fall, and are prone to significant price fluctuations due to the influence of bookmakers, and global government policies.",
        content7: "4 The Company reserves the right to suspend or terminate your account, or to suspend or terminate your use of the services provided by the Site or the trading of digital assets at any time if, in its sole discretion, it believes that you have violated this Agreement or that the services provided by the Site or your use of the services provided by the Site is unlawful under the laws of your jurisdiction. Any person from [China, Taiwan, Israel, Iraq, Bangladesh, Bolivia, Ecuador, Kyrgyzstan, Sevastopol, United Kingdom (retail users)] is prohibited from using the contract trading services offered on this website . The foregoing list of countries or regions is subject to change depending on the policies and product types of different countries or regions and may not be specifically notified to you at that time, so please check back for updates to this Agreement.",
        content8: "Trading in digital assets carries an extremely high level of risk and is not suitable for the vast majority of people. You understand that trading may result in a partial or total loss and you should decide how much you can afford to lose. You understand and appreciate that there are derivative risks associated with digital assets and therefore if in any doubt, it is advisable to seek the assistance of a professional adviser first. In addition, in addition to the risks mentioned above, there are also unpredictable risks. You should make any decision to buy or sell digital assets based on a careful and informed assessment of your financial position and the risks mentioned above, and you assume full responsibility for any losses arising therefrom, for which we accept no liability.",
        content9: "To you.",
        content10: "1 You understand that this website is only a place for you to obtain information about digital assets, find counterparties, negotiate and conduct transactions in digital assets, and that this website is not involved in any of your transactions, so you should exercise your own discretion in determining the authenticity, legality and validity of the relevant digital assets and/or information, and bear your own liability and losses arising therefrom.",
        content11: "2 Any opinions, news, discussions, analysis, prices, recommendations and other information on this website are general market commentary and do not constitute investment advice. We do not accept any liability for any loss arising directly or indirectly from reliance on such information, including but not limited to any loss of profit.",
        content12: "3.We have taken reasonable steps to ensure the accuracy of the information on this website but cannot guarantee its accuracy and will not be liable for any loss arising directly or indirectly from the information on this website or from any delay or failure in linking to the internet, transmitting or receiving any notices and information.",
        content13: "4 The use of Internet-based trading systems is subject to risks, including but not limited to software, hardware and Internet connection failures. As we have no control over the reliability and availability of the Internet, we cannot be held liable for distortions, delays and connection failures. ",
        content14: "5 It is prohibited to use this website to engage in money laundering, smuggling, commercial bribery and other illegal trading activities or illegal acts. If any suspected illegal trading or illegal acts are found, this website will take various means available, including but not limited to freezing the account, notifying the relevant authorities, etc. We do not assume all responsibilities arising from this and reserve the right to pursue responsibilities from the relevant parties.",
        content15: "6 It is prohibited to use this website for malicious market manipulation, improper trading and all other unethical trading activities. If such incidents are found, this website will take preventive protective measures such as warning, restricting trading, closing accounts and other preventive measures against all malicious price manipulation, malicious influence on the trading system and other unethical behaviours, and we disclaim all liability arising therefrom and reserve the right to pursue responsibility from the relevant parties.",
        content16: "1. General Provisions",
        content17: '1.1 The User Agreement (hereinafter referred to as "this Agreement" or "these Terms and Conditions") consists of the text, the Privacy Policy, the Know Your Customer and Anti-Money Laundering Policy and various rules, statements and instructions that have been published or may be published in the future on this website etc.',
        content18: "1.2 You should read this Agreement carefully before using the services provided on the Website and consult a professional lawyer if you do not understand it or if it is otherwise necessary. If you do not agree with this Agreement and/or any changes to it from time to time, you should immediately stop using the services provided by the Website or stop accessing the Website. By accessing the Site, using any of the services on the Site or any other similar conduct, you acknowledge that you have understood and fully agree to the terms of this Agreement, including any modifications to this Agreement made by the Site from time to time.",
        content19: '1.3 You can become a member of this website (hereinafter referred to as "Member") by filling in the relevant information in accordance with the requirements of this website and successfully registering after going through other relevant procedures. In the process of registration, clicking on the "Agree" button means that you have reached an agreement with the Company in the form of an electronic signature; or when you click on any button marked "Agree" or similar meaning in the process of using this website or actually use the services provided by this website in other ways permitted by this website, you fully understand, agree and accept to be bound by all the terms and conditions under this agreement, and the absence of your handwritten written signature does not The absence of your handwritten signature does not affect the legally binding effect of this Agreement on you.',
        content20: "1.4 Upon becoming a member of this website, you will be given a member account and corresponding password, which you are responsible for keeping; you shall be legally responsible for all activities and events conducted under your account.",
        content21: "1.5 Only members of this website can use the digital asset trading platform provided by this website to trade and enjoy other services provided by this website which are only available to members; non-members can only access the website, browse the website and other services provided by this website.",
        content22: "1.6 By registering and using any of the services and features offered on the Website, you will be deemed to have read, understood and.",
        content23: "1.6.1 To be bound by all the terms and conditions of this Agreement.",
        content24: "1.6.2 You confirm that you are 18 years of age or older or of legal age to enter into a contract under different applicable laws, that your registration, sale or purchase, posting of information and other acceptance of services on the Site shall be in accordance with the relevant laws and regulations of the sovereign country or territory having jurisdiction over you and that you have sufficient capacity to accept these terms and enter into transactions and use the Site for digital assets Transactions.",
        content25: "1.6.3 You warrant that the digital assets belonging to you involved in the transaction have been legally acquired and are subject to ownership.",
        content26: "1.6.4 You agree that you are solely responsible for your own trading or non-trading actions and any gains or losses.",
        content27: "1.6.5 You confirm that the information you provide when registering is true and accurate.",
        content28: "1.6.6 You agree to comply with any relevant legal requirements for tax purposes, including the reporting of any trading profits.",
        content29: "1.6.7 You agree not at any time to engage or participate in conduct or activities that are detrimental to the interests of the Site or the Company, whether or not in connection with the services provided on the Site.",
        content30: "1.6.8 This Agreement only governs the rights and obligations agreed between you and us, and does not cover legal relationships and legal disputes between users of the Website and other websites and between you as a result of transactions in digital assets.",
        content31: "2. amendment of agreement",
        content32: "We reserve the right to amend this Agreement from time to time by posting it on the Website without separate notice to you, and such amendments will be posted on the [Last Updated] page of this Agreement and will automatically become effective upon posting on the Website. If you do not agree with the changes, you should immediately stop using the Services; by continuing to use the Services, you accept and agree to be bound by the revised Agreement.",
        content33: "3. Registration",
        content34: "3.1 Eligibility for registration",
        content35: "You acknowledge and undertake that you shall be a natural person, legal entity or other organisation with the capacity to sign this agreement and use the services of this website in accordance with applicable law when you complete the registration process or actually use the services provided by this website in any other way permitted by this website. Once you click on the button to agree to register, it means that you yourself or your authorized agent have agreed to the content of the agreement and to be represented by him/her to register and use the services of this website. If you do not have the aforementioned qualifications, you and your authorized agent shall be liable for all consequences arising therefrom and the Company reserves the right to cancel or permanently block your account and to pursue liability against you and your authorized agent.",
        content36: "3.2 Purpose of registration",
        content37: "You acknowledge and undertake that you are not registering on this website for the purpose of violating laws and regulations or disrupting the orderly trading of digital assets on this website",
        content38: "3.3 Registration process",
        content39: "3.3.1 You agree to provide a valid email address, mobile phone number and other information as required on the user registration page of this website, and you may use the email address or mobile phone number you provide or confirm or other means permitted by this website as a means of accessing this website. If necessary, in accordance with the relevant laws and regulations of different jurisdictions, you must provide your real name, identity document and other relevant information as stipulated in the laws and regulations and the privacy and anti-money laundering provisions and keep the registration data updated to meet the requirements of being timely, detailed and accurate. All information originally keyed in will be quoted as registration data. You are responsible for the truthfulness, completeness and accuracy of such information and shall be liable for any direct or indirect losses and adverse consequences arising therefrom.",
        content40: "3.3.2 If the laws, regulations, rules, orders and other norms of your sovereign country or region require a real name for a mobile phone number, you agree to provide that the registered mobile phone number is registered with your real name and if you do not provide it in accordance with the regulations, any direct or indirect losses and adverse consequences to you as a result shall be borne by you.",
        content41: "3.3.3 You are entitled to obtain an account number and password for this website if you provide the information required for registration legally, completely and effectively and are verified.",
        content42: "3.3.4 You agree to receive emails and/or short messages from this website in connection with the administration and operation of this website.",
        content43: "4. Services",
        content44: "This website only provides internet trading platform services for your digital asset trading activities (including but not limited to services such as digital asset trading) through this website.",
        content45: "4.1 Services",
        content46: "4.1.1 You have the right to view real-time quotes and trading information of various products of digital assets on the Website and to submit orders and complete transactions in digital assets through the Website.",
        content47: "4.1.2 You have the right to view the information under your member account on this website and to use the functions provided on this website.",
        content48: "4.1.3 You have the right to participate in website activities organised by this website in accordance with the activity rules published on this website.",
        content49: "4.1.4 Other services that this website promises to provide to you.",
        content50: "4.2 Service Rules You undertake to abide by the following service rules for this website.",
        content51: "4.2.1 You shall comply with the provisions of laws, regulations, and policy requirements, ensure the legality of the source of all digital assets in your account, and shall not engage in illegal or other activities that harm the rights and interests of the Website or third parties on the Website or using the Website services, including but not limited to sending or receiving any information that is illegal, violates the law, infringes the rights and interests of others, sending or receiving marketing materials or other harmful information or speech, using or falsifying the email header information of this website without the authorisation of this website, etc.",
        content52: "4.2.2 You shall comply with laws and regulations and use and keep your account and login password, funds password, mobile phone number tied to your registration, and mobile phone verification code received by your mobile phone. You are solely responsible for any actions and consequences of using your account and login password, funds password and mobile phone verification code. When you discover that your account number, login password, or funds password or verification code of this website is used by a third party without your authorization, or there are other account security problems, you should immediately and effectively notify this website and request this website to suspend the service of your account on this website. This website has the right to take action on such request from you within a reasonable time, but this website shall not be liable for any consequences (including but not limited to any loss incurred by you) that have arisen before the action is taken. You may not give, borrow, rent, transfer or otherwise dispose of your account on this website to another person without the consent of this website.",
        content53: "4.2.3 You agree to be responsible for all activities that occur under your account and password on the Website (including but not limited to disclosing information, posting information, clicking online to agree to or submit to various rule agreements, renewing agreements online or purchasing services, etc.).",
        content54: "4.2.4 You shall not maliciously interfere with the normal conduct of digital asset transactions or disrupt the order of transactions when trading digital assets on this website; you shall not interfere with the normal operation of this website or interfere with other users' use of the services of this website by any technical means or otherwise; you shall not maliciously defame the goodwill of this website by falsifying facts or other means.",
        content55: "4.2.5 If you have disputes with other users due to online transactions, you shall not request the Website to provide relevant information through channels other than judicial or administrative ones.",
        content56: "4.2.6 The taxable expenses incurred by you in the course of using the services provided by this website, as well as all hardware, software, services and other aspects, shall be judged and borne by you alone.",
        content57: "4.2.7 You shall comply with this Agreement and other terms of service and operating rules published and updated from time to time on this website and shall have the right to terminate the use of the services provided by this website at any time.",
        content58: "4.3 Product Rules",
        content59: "4.3.1 Browse transaction information",
        content60: "When browsing the trading information on this website, you should carefully read all the contents contained in the trading information, including but not limited to the price, order quantity, commission, buy or sell direction, and you should not click the button to trade until you fully accept all the contents contained in the trading information.",
        content61: "4.3.2 Viewing transaction details",
        content62: "You can view the corresponding transaction records through your account.",
        content63: "5. Rights and obligations of the Website",
        content64: "5.1 If you do not have the registration qualifications agreed in this Agreement, the Website has the right to refuse your registration, and for those who have registered, the Website has the right to cancel your membership account, and the Website reserves the right to pursue responsibility from you or your authorized agent. At the same time, this website reserves the right to decide whether to accept your registration under any other circumstances.",
        content65: "5.2 According to the Site's own judgment, the Site has the right to suspend or terminate your account and all associated accounts if it finds that you or your associated account users are not suitable for high-risk investments.",
        content66: "5.3 If the Website finds that the account user is not the initial registrant of the account, it has the right to suspend or terminate the use of the account.",
        content67: "5.4 This website has the right to notify you to correct or update the information or suspend or terminate the provision of services on this website if we reasonably suspect that the information provided by you is incorrect, inaccurate, invalid or incomplete through technical testing, manual sampling and other testing methods.",
        content68: "5.5 This website reserves the right to correct any information displayed on this website if it is found to be obviously incorrect.",
        content69: "5.6 The Website reserves the right to modify, suspend or terminate the services of the Website at any time, and the Website exercises the right to modify or suspend the services without informing you in advance; if the Website terminates one or more services of the Website, the termination will take effect from the date of the announcement of termination published on the Website.",
        content70: "5.7 This website will take the necessary technical means and management measures to ensure the normal operation of this website and provide the necessary and reliable trading environment and trading services to maintain the order of digital asset trading.",
        content71: "5.8 If you have not used the Website member account and password to log in to the Website for one consecutive year, the Website has the right to cancel your account on the Website. After the account is cancelled, the Website has the right to open the corresponding membership name for other users to register and use.",
        content72: "5.9 This website safeguards the security of your digital assets by strengthening technical investment and enhancing security precautions, and will notify you in advance of any foreseeable security risks to your account.",
        content73: "5.10 This website has the right to delete all kinds of content information in this website that does not comply with laws and regulations or the regulations of this website at any time, and this website exercises such rights without prior notice to you.",
        content74: "5.11 This website has the right to request more information or data from you in accordance with the laws and regulations, rules, orders and other norms of the sovereign country or region to which you belong, and to take reasonable measures to comply with the requirements of local norms, and you are obliged to cooperate; this website has the right to suspend or permanently stop opening this Part or all of the services on the website.",
        content75: "5.12 The Website reserves the right to close your account at its sole discretion upon seven working days' notice. Accordingly, you have seven business days to withdraw your orders and close your positions. If you have not withdrawn and closed your order by the end of this period, we will force you to withdraw and close your order and return any remaining digital assets in your account to you.",
        content76: "5.13 To protect the rights and interests of traders, our website has the right to adjust the products that are already online under special circumstances (e.g. system failure, network failure, extreme quotes, etc.), e.g. contracts for early delivery and settlement, the contract types, contract periods and settlement and delivery prices for early delivery and settlement shall be subject to the announcement on our website.",
        content77: "6. Compensation",
        content78: "6.1 In no event will our liability to you for direct damages exceed the total service fee we charge you for your use of the Site for a period of three (3) months.",
        content79: "6.2 In the event of any breach by you of this Agreement or other laws or regulations, etc., you shall indemnify us for at least US$2,000,000 and all costs incurred in connection therewith (including attorneys' fees, etc.), which shall be made up if not sufficient to cover actual damages.",
        content80: "7. right to seek injunctive relief",
        content81: "We and you acknowledge that common law remedies for your breach or threatened breach may not be sufficient to cover the full amount of damages we have suffered, and we are therefore entitled to seek injunctive relief in the event of your breach or threatened breach and all other remedies permitted by common law or equity.",
        content82: "8. Limitation of Liability and Exclusion of Liability",
        content83: "8.1 You understand and agree that in no event shall we be liable in respect of",
        content84: "8.1.1 Loss of revenue.",
        content85: "8.1.2 Loss of trading profits or contracts.",
        content86: "8.1.3 Losses caused by business interruption.",
        content87: "8.1.4 Loss of expected monetary savings.",
        content88: "8.1.5 Losses due to information problems.",
        content89: "8.1.6 Loss of opportunity, goodwill or reputation.",
        content90: "8.1.7 Damage to or loss of data.",
        content91: "8.1.8 The cost of purchasing alternative products or services.",
        content92: "8.1.9 any indirect, special or incidental loss or damage arising out of tort (including negligence), breach of contract or any other cause, whether or not such loss or damage was reasonably foreseeable by us; whether or not we were previously advised of the possibility of such loss or damage.",
        content93: "Clauses 8.1.1 to 8.1.9 are independent of each other.",
        content94: "8.2 You understand and agree that we shall not be liable to you for any damages arising out of any of the following.",
        content95: "8.2.1 there may be a material breach of law or contract in relation to your particular transaction",
        content96: "8.2.2 Your conduct on the Site is suspected to be illegal or unethical.",
        content97: "8.2.3 Costs and losses arising from acts or substitutes such as purchasing or obtaining any data, information or conducting transactions through the services of this website.",
        content98: "8.2.4 any misunderstanding by you of the services on this website.",
        content99: "8.2.5 Any other loss arising in connection with the services provided on this website which is not attributable to us.",
        content100: "8.3 We are not liable for any loss or damage arising from maintenance of information network equipment, failure of information network connectivity, failure of computers, communications or other systems, power failure, weather, accident, strike, labour dispute, riot, insurrection, disturbance, lack of productivity or means of production, fire, flood, storm, explosion, war, bank or other partner causes, collapse of the market for digital assets, government action, order of judicial or administrative authorities, any other loss or damage not within our control. orders, other acts outside our control or beyond our ability to control, or third parties, and we will not be liable for any failure to provide or delay in providing the Services and for any losses incurred by you.",
        content101: "8.4 We cannot guarantee that all information, programs, text, etc. contained on this website are completely safe and secure from any viruses, Trojan horses and other malicious programs and damage, so your access to, use of any services on this website or downloading and use of any programs, information, data, etc. downloaded is your personal decision and you bear your own risk and possible losses.",
        content102: "8.5 We make no warranties or undertakings whatsoever in relation to any information, products and services on any third party websites linked to this website or any other content of any kind which is not our subject matter and your use of any services, information and products provided by third party websites is at your own discretion and you assume all liability arising therefrom.",
        content103: "8.6 We do not make any express or implied guarantees for your use of the services on this website, including but not limited to the applicability of the services provided by this website, no errors or omissions, continuity, accuracy, reliability, and applicability to a certain Specific purpose. At the same time, we do not make any promises or guarantees regarding the validity, accuracy, correctness, reliability, quality, stability, completeness and timeliness of the technology and information involved in the services provided on this website. Whether to log in or use The services provided on this website are your personal decision and at your own risk and possible losses. We do not make any express or implied guarantees regarding the market, value and price of digital assets. You understand and understand that the digital asset market is unstable Yes, prices and values ​​will fluctuate sharply or collapse at any time. Trading digital assets is your personal free choice and decision, and at your own risk and possible losses.",
        content104: "8.7 Our warranties and undertakings set out in this Agreement are the only warranties and representations made by us in relation to this Agreement and the services provided on the Website and supersede all other warranties and undertakings, whether written or oral, express or implied, arising from any other means or manner. All such warranties and representations represent only our own undertakings and warranties and do not guarantee compliance by any third party with the warranties and undertakings in this Agreement.",
        content105: "8.8 We do not waive any rights we may have to limit, exclude or set off our liability for damages to the fullest extent applicable by law which are not mentioned in this agreement.",
        content106: "8.9 By registering, you acknowledge that any actions taken by us in accordance with the rules set out in this Agreement are at your risk.",
        content107: "9.Termination of the Agreement ",
        content108: "9.1 The Website has the right to terminate all services of the Website in accordance with this Agreement, and this Agreement shall terminate on the date of termination of all services of the Website.",
        content109: "9.2 After the termination of this Agreement, you have no right to request the Website to continue to provide any services to you or to fulfill any other obligations, including but not limited to requesting the Website to retain or disclose to you any information in its original Website account, forwarding to you or a third party any information that it has not read or sent, etc.",
        content110: "9.3 The termination of this Agreement shall not affect the defaulting party's claim for additional liability against the breaching party.",
        content111: "10.Intellectual Property Rights ",
        content112: "10.1 The intellectual property rights in all intellectual output contained in this website including but not limited to the website logo, database, website design, text and graphics, software, photographs, videos, music, sound and combinations thereof, software compilations, related source code and software (including applets and scripts) are owned by this website. You may not reproduce, modify, copy, send or use any of the foregoing material or content for commercial purposes.",
        content113: "10.2 All rights (including but not limited to goodwill and trademarks and logos) contained in the name of the Website are owned by the Company.",
        content114: "10.3 By accepting this agreement, you are deemed to have voluntarily and exclusively transferred the copyright of any form of information published by you on this website, including but not limited to: reproduction rights, distribution rights, rental rights, exhibition rights, performance rights, projection rights, broadcasting rights, information network transmission rights, filming rights, adaptation rights, translation rights, compilation rights and other transferable rights that should be enjoyed by the copyright owner to this website without any compensation, and this website The right to file a separate lawsuit against any subject for infringement and obtain full compensation. This Agreement shall apply to the content of any work protected by copyright law posted by you on the Website, whether such content is formed before or after the signing of this Agreement.",
        content115: "10.4 You may not unlawfully use or dispose of the Site or the intellectual property rights of others in the course of using the Site. You may not publish information on this website in any form or authorise other websites (and media) to use it.",
        content116: "11. Protection of information",
        content117: 'The agreement of the Privacy Policy, which is published separately on this website, shall prevail.',
        content118: "12. Calculations",
        content119: "All transaction calculations have been verified by us and all calculations have been published on the website, but we cannot guarantee that the use of the website will be uninterrupted or error-free.",
        content120: "13. export controls",
        content121: "You understand and acknowledge that you are prohibited from exporting, re-exporting, importing or transferring any material (including software) from the Website in accordance with relevant laws, and therefore you warrant that you will not initiate or assist or participate in any such export or related transfer in violation of regulations or other violations of applicable laws and regulations; if you discover such circumstances, you should promptly and actively report them to us and assist us in dealing with them.",
        content122: "14. Assignment",
        content123: "The rights and obligations agreed in this Agreement shall equally bind the assignees, successors, executors and administrators of the parties who derive benefit from such rights and obligations. You may not assign to any third party without our consent, but we may assign our rights and obligations under this Agreement to any third party at any time by giving you notice.",
        content124: "15. Severability",
        content125: "If any provision of this Agreement is held to be unenforceable, invalid or illegal by any court of competent jurisdiction, this will not affect the validity of the remaining provisions of this Agreement.",
        content126: "16. non-agency relationship",
        content127: "Nothing in this Agreement shall be deemed to create, imply or otherwise treat us as your agent, fiduciary or other representative, except as otherwise provided in this Agreement.",
        content128: "17. waiver of rights",
        content129: "No waiver by us or by either of you of any liability to pursue a breach of contract or other liability agreed to in this Agreement shall be deemed or construed as a waiver of any other liability for breach; and the failure to exercise any right or remedy shall not in any way be construed as a waiver of such right or remedy.",
        content130: "18. Headings",
        content131: "All headings are for convenience only and are not intended to expand or limit the content or scope of the terms of this agreement.",
        content132: "19. applicable law",
        content133: "19.1 Before filing a dispute or claim, you acknowledge and agree to first contact the Site via email to resolve the dispute informally and we will attempt to resolve your dispute internally as soon as possible; both parties agree to resolve the dispute by good faith negotiation (discussions shall be confidential and protected from use as evidence in any legal proceedings by applicable rules).",
        content134: '19.2 You acknowledge and agree that in the event of any dispute, controversy, difference or claim, including the existence, validity, interpretation, performance, breach or termination of these Terms or any dispute arising out of or in connection with these Terms ("Dispute"), the said parties shall, in accordance with the Rules of Arbitration of the International Chamber of Commerce for the time being in force, refer the Dispute to the International Court of Arbitration of the International Chamber of Commerce ("ICC International Court of Arbitration"). The place of arbitration shall be Belize and the law applicable to the arbitration shall be determined in accordance with the ICC Rules of Arbitration. Unless otherwise agreed by the parties, only one arbitrator shall be appointed under the ICC Arbitration Rules. The arbitrator shall have the exclusive power to rule on his or her own jurisdiction, including but not limited to any challenge to the existence, scope or validity of the arbitration agreement or the arbitrability of any claim or counterclaim. Any arbitration will be conducted in the English language. Regardless of the manner in which the arbitration is conducted, the arbitrator shall issue a reasoned written award sufficient to explain the award and the underlying findings and conclusions (if any) on which the award is based. The arbitration award shall be final, binding on the parties and enforceable in any court of competent jurisdiction.',
        content135: "20. Entry into force and interpretation of the Agreement",
        content136: "20.1 This Agreement shall come into effect when you click on the consent to register on the registration page of the Website and complete the registration process and obtain an account and password for the Website and shall be binding on both the Website and you.",
        content137: "20.2 The final interpretation of this Agreement is the property of the Website.",
        content138: "Know Your Customer and Anti-Money Laundering Policy",
        content139: "1. Introduction",
        content140: '1.1 We promise to prudently abide by the laws and regulations related to "know your customers" and anti-money laundering and shall not intentionally violate the "know your customers and anti-money laundering policy". We will take necessary measures within the scope of our reasonable control And technology provides you with safe services, as far as possible to protect you from the loss caused by the money laundering behavior of criminal suspects.',
        content141: "1.2 Our Know Your Customer and Anti-Money Laundering Policy is a comprehensive body of international policies, including the Know Your Customer and Anti-Money Laundering Policies of the different legal jurisdictions to which you belong.",
        content142: "2. The Know Your Customer and Anti-Money Laundering Policy is as follows.",
        content143: "2.1 Promulgate a know-your-customer and AML policy and update it from time to time to meet the standards required by the appropriate laws and regulations.",
        content144: "2.2 To promulgate and update certain guidelines and rules for the operation of the Site and that our staff will provide services in accordance with the guidance in those guidelines and rules.",
        content145: "2.3 Designing and completing internal procedures for monitoring and controlling transactions, such as strict means of identity verification and arranging for the formation of specialist teams dedicated to anti-money laundering.",
        content146: "2.4 To apply a risk prevention approach to customer due diligence and ongoing supervision.",
        content147: "2.5 Reviewing and regularly examining transactions that have taken place.",
        content148: "2.6 Reporting suspicious transactions to the competent authorities.",
        content149: "2.7 Supporting documentation of identity, proof of address and transaction history will be maintained for at least six years without notice to you if they are submitted to the regulatory authorities.",
        content150: "3. identification information and verification confirmation",
        content151: "3.1 Identity information",
        content152: "3.1.1 The content of the information we collect about you may vary depending on the different regulations of different jurisdictions and different types of entities, and in principle the following information will be collected from registered individuals.",
        content153: "Basic personal information: your name, address (and permanent address, if different), date of birth and other information available such as nationality. Verification should be based on an official or other similar authority issued document such as a passport, identity card or other identification document required and triggered by the different jurisdictions. The address you provide will be verified using appropriate methods, such as checking tickets for travel by public transport or interest rate tickets or checking the electoral register.",
        content154: "A valid photograph: before you can register, you will be required to provide a photograph of you with your ID on your chest.",
        content155: "Contact details: telephone/mobile number and/or a valid email address.",
        content156: "3.1.2 If you are a company or other legal entity, we will collect the following information to identify you or the ultimate beneficiary of the trust account",
        content157: "A copy of the company's registration, certificate of incorporation; a copy of the company's articles of association and memorandum; detailed supporting documentation of the company's shareholding body and statement of ownership, a board resolution evidencing the authorised delegate who decided to open the account on this website and its execution; identification documents of the company's directors, majority shareholders and authorised signatories to the account on this website as required; the company's principal business address and, if different from the company's postal address If different from the company's postal address, provide the postal address. If the company's local address is not the same as its main business address, it is considered a higher risk client and additional documentation will be required.",
        content158: "Depending on the regulations of the different jurisdictions and the type of entity, we require additional certifications and documents issued by the authorities as well as those we deem necessary.",
        content159: "3.1.3 We will only accept the English version or the Chinese version of your identity information, if not, please have your identity information translated into the English version and notarised.",
        content160: "3.2 Confirmation verification",
        content161: "3.2.1 We require you to provide the full contents of the pages of your identification document.",
        content162: "3.2.2 We ask you to provide us with a photograph of you with your identification document on your chest.",
        content163: "3.2.3 A copy of the supporting document should normally be checked against the original voucher. However, if a trusted and appropriate certifier can certify that the copy is an accurate and complete reproduction of the original document, the copy is acceptable. Such certifiers include ambassadors, judicial commissioners, magistrates, etc.",
        content164: "3.2.4 The requirements for identifying the ultimate beneficiary and control of the account are to identify which individuals ultimately own or control the direct customer and/or to identify that the transaction being carried out is being executed on behalf of someone else. In the case of a business, the identity of the majority shareholders (e.g. those holding 10% or more of the voting interest) should be verified. Generally, a 25 per cent shareholding is considered to be within normal risk and the identity of the shareholder is verified; a 10 per cent or greater shareholding in voting rights or shares is considered to be a high risk situation and the identity of the shareholder is verified.",
        content165: "4. monitoring transactions",
        content166: "4.1 We set and adjust the maximum daily transaction and withdrawal limits from time to time based on security and actual trading conditions;",
        content167: "4.2 If transactions are frequently concentrated on a registered user or in circumstances that are beyond reasonable, our professional team will assess and decide if they are suspicious;",
        content168: "4.3 Where we determine in our sole discretion that a transaction is suspicious, we may take restrictive measures such as suspending the transaction, rejecting the transaction, or even reversing the transaction as soon as possible if possible, and reporting it to the competent authorities without informing you;",
        content169: "4.4 We reserve the right to refuse registration applications from persons who do not meet international anti-money laundering standards jurisdictions or who may be considered politically exposed persons and we reserve the right to suspend or terminate transactions that we determine to be suspicious in our sole discretion at any time, provided that we do so without breaching any of our obligations and duties to you.",
    },
    register: {
        emailRegister: "Email Register",
        phoneRegister: "Phone Register",
        formTitle1: 'Create',
        formTitle2: 'Register with your email or mobile number',
        formTitle3: 'Account',
        field1: 'Verification code',
        field2: 'Obtain',
        field3: 'Confirm Password',
        field4: 'Invite code',
        field41: '(optional)',
        field5: 'I have read and agree to',
        field6: 'Terms of Service',
        placeholder1: 'Enter verification code',
        content7: 'Please enter verification code',
        content12: 'Please enter your mobile phone number',
        content13: 'Please enter your password',
        content14: 'Please enter your email address',
        content18: 'Please enter your password again',
        content19: 'Please agree to the terms of service',
        content20: 'Please enter the correct verification code',
        content23: "Still haven't received the verification code?",
        content24: 'Please enter the code below',
        registerSuccess: 'Register successful ',
        content25: 'Password does not match',
        content26: 'Please input the correct email address',
        content27: 'Password reset successful'
    },
    download: {
        content1: 'Trading, anytime, anywhere',
        content2: 'Perfectly compatible with Multiple platforms, ready to meet the transaction needs of various scenarios',
        content3: 'View live quotes at any time',
        content4: 'Buy and sell BTC, ETH, XRP and other digital assets with ease',
        content5: 'Get alerts on price changes in the Cryptocurrencies you follow',
        content6: 'View Bitcoin Spot,Futures,Options Prices',
        content7: 'Compare cryptocurrency prices on various exchanges',
        title: 'Download',
        install: 'Installation instructions',
        one: '1. Allows the description file to be downloaded',
        two: '2. The description file has been downloaded',
        three: '3. Enter the phone [Settings] to find [General]',
        four: '4. Describes the file and device manager',
        five: '5. Click on the description file',
    },
    identity: {
        noAuthentication: {
            title: 'Basic Verification',
            pleaseSelectYourCountry: 'Please Select Your Country',
            name: 'Name',
            enterName: 'Please Enter Your Name',
            city: 'City',
            enterCity: 'Please Enter Your City',
            IDNumber: 'ID Number',
            enterIDNumber: 'Please Enter Your ID Number',
        },
        noAdvancedAuthentication: {
            title: 'Advanced Verification',
            infoCountry: 'Country / Region',
            infoName: 'Name',
            infoNumber: 'license number',
            infoAddress: 'Address',
        },
        text: 'Not certified',
        recertification: 'Recertification',
        certification: 'Certification',
        authenticationInProgress: 'Authenticated',
        inAuthentication: 'in authentication',
        uploadTheFrontOfTheDocument: 'Upload front side of certificate',
        uploadTheReverseSideOfTheDocument: 'Reverse side of upload certificate',
        uploadAPhotoOfAHandHeldID: 'Upload hand-held ID photos',
        pleaseUpload: 'Please ',
        pleaseCompleteOrdinaryCertificationFirst: 'Please complete ordinary certification first',
        refused: 'Refused',
        reason: 'Reason',
        succeeded: "Succeeded",
        uploading: 'On the cross',
        newTitle: 'Select the country of issue of your document',
        pleaseOrdinaryCertificationFirst: "Please perform primary certification first",
        text1: "Modify avatar",
        text2: "nickname",
        text3: "Account",
        text4: "Nickname modification",
        text5: "New nickname",
        text6: "Enter your new nickname",
        text7: "Old password",
        text8: "Enter your old password",
        text9: "New password",
        text10: "Enter your new password",
        text11: "Confirm password",

        text12: "Enter your new password again",
        text13: "New Email",
        text14: "Verification code",
        text15: "Please enter the verification code",
        text16: "Your mobile phone number",
        text17: "New mobile number",
        text18: "Please enter your mobile phone number",
        text19: "Mobile phone verification code",
        text20: "Primary Certification",
        text21: "Please verify your identity information",
        text22: "Country",
        text23: "City",
        text24: "Enter your city",
        text25: "Enter your name",
        text26: "Your ID number",
        text27: "Enter your ID number",
        text28: "Front photo of ID card",
        text29: "Click to upload your certificate",
        text30: "Reupload",
        text31: "Upload",
        text32: "Hold ID photo",
        text33: "Click to upload your holding ID photo",
        text34: "You have bound Google Authenticator",
        text35: "Key",
        text36: "Please enter the Google verification code",
        text37: "Send",
        text38: "cannot be empty",
        text39: "The email format is incorrect",
        text40: "Two passwords are inconsistent",
        text41: "Copy successfully",
        text42: "Copy failed",
        text43: "Avatar modification",
        text44: "Change password",
        text45: "Email binding",
        text46: "Modify email",
        text47: "Mobile phone binding",
        text48: "Modify mobile phone",
        text49: "Google Verification",
        text50: "Bind Google Authenticator",
        text51: "Enter the Google verification code",
        text52: "Save",
        text53: "Confirm submission",
        text54: "Modify",
        text55: "binding",
        text56: "Turn off Google verification",
        text57: "Next step",
        text58: "Complete",
        text59: "Google verification has been bound",
        text60: "Google verification has been unbound",
        text61: "Primary certification has been submitted",
        text62: "Advanced certification has been submitted",
        text63: "No image uploaded",
        text64: "Resend",
        text65: "Please enter your nickname",
        text66: "Nickname saved successfully",
        text67: "The image has not been uploaded yet",
        text68: "Password changed successfully",
        text69: "Email modified successfully",
        text70: "Avatar saved successfully",
        text71: "Upload image",
        text72: "Your email",
        text73: "Enter your new email address",
        text74: "Your name",
        text75: "De-authentication",
        text76: "Please verify your holding ID photo"
    },
    retrievePassword: {
        formTitle1: 'Reset Password',
        formTitle2: 'For the safety of your assets, transactions are prohibited for 24 hours after changing your password.',
        formTitle3: ' Retrieve password',
        formTitle4: 'Confirm the changes',
        formTitle5: 'Please enter old password',
        formTitle6: 'Please enter a new password'
    },
    home: {
        title1: 'The Most Secure Cryptocurrency Trading Platform',
        title3: 'Why is it ',
        title4: ' is a high-performance open source blockchain platform designed to support and operate a secure, compliant and predictable digital infrastructure. ',
        field1: 'Old Exchange',
        field2: 'Digital Asset Financial Services',
        field3: '10 million users',
        field4: 'Establishment of multiple investor protection funds',
        field5: 'Fast transaction',
        field6: ' is able to match orders with ultra-low latency for the ultimate trading experience.',
        title5: 'Market Trends',
        title6: 'More',
        table1: 'Currency',
        table2: 'Price',
        table3: '24H Change',
        table4: '24H Vol',
        table5: '24H Turnover',
        table6: 'Markets',
        title7: 'About ',
        title8: ' to providing users with the most advanced trading tools, innovative technology and unparalleled quality customer service.',
        title9: 'The field of digital assets is changing with each passing day, and only with foresight and swift progress can we keep up with the rapid technological innovation.',
        title901: ' our users and global liquidity providers with the most advanced digital asset trading services.',
        title10: 'We firmly believe that every user deserves the best trading experience.',
        title11: 'Security that you can trust',
        title12: 'Our sophisticated security measures combined with SAFU funds protect your digital assets from all risks. ',
        title13: 'Optimal trading rates',
        title14: 'Preferential transaction rates, competitive VIP benefits and access to the best quality service. ',
        title15: '24*7 hours customer service support',
        title16: '24/7, full-time operation mode, the first time to answer your relevant inquiries. ',
        title17: '0 transaction fee',
        title18: 'Trade digital currencies using a variety of payment methods, with 0 fees, securely and quickly. ',
        title19: 'Trading, anytime, anywhere',
        title20: 'Perfectly compatible with Multiple platforms, ready to meet the transaction needs of various scenarios',
        title21: 'View live quotes at any time',
        title22: 'Buy and sell BTC, ETH, XRP and other digital assets with ease',
        title23: 'Get alerts on price changes in the Cryptocurrencies you follow',
        title24: 'View Bitcoin Spot,Futures,Options Prices',
        title25: 'Compare cryptocurrency prices on various exchanges',
        title26: 'Sign up now',
        title27: 'Dollar',
        title28: '24-hour trading volume',
        title29: 'Integrated liquidity provider',
        title30: 'User',
        title31: 'More',
        title32: 'Binance Loan adds CTSI&KSM as mortgage assets and launches BUSD&USDT interest rate cut discounts!',
        title33: 'Our Advantage',
        title34: 'Safe and stable',
        title35: "The top-notch technical team, comprehensive security protection, independent research and development of high-speed transaction engine, stable and reliable operation under massive concurrent transactions.",
        title36: 'Professional compliance',
        title37: 'Professional operation team, years of experience in blockchain and financial industry, holding a compliant digital asset trading license, and a 100% deposit guarantee.',
        title38: 'User first',
        title39: 'Facing the global market, multi-language support, 7*24 hours uninterrupted operation, strong community support, and professional customer service.',
        title40: 'High performance',
        title41: 'With 300,000 transactions per second, the order response time is less than 1 millisecond.',
        title42: 'About US',
        title43: 'Trade anytime, anywhere',
        title44: 'Perfectly compatible with multiple terminals, meeting the transaction needs of various scenarios at any time',
        title45: '(Scan code to download)',
        title46: 'Digital Currency News',
        title47: 'Our business partner',
        title48: 'Top Losers',
        title49: '24h turnover',
        title50: '24h change'
    },
    quotation: {
        marketTrading: 'Market Trading',
        turnover: 'Turnover',
        optional: 'Favorites',
        contractMarket: 'Contracts Market',
        currencyPair: 'Pair',
        latestPrice: 'Price',
        upsAndDowns: 'Change',
        highest: 'High',
        lowest: 'Low',
        transactionAmount: 'Turnover',
        operate: 'Action',
        buy: 'Trade',
        topTurnovers: 'Volume',
        topGainers: 'Change',
        tradingPair: 'Pair',
        buyOrder: 'Buy',
        sellOrder: 'Sell'
    },
    accountChange: {
        demo: "DEMO",
        realAccount: 'Real Account',
        demoAccount: "Demo Account",
        accountRole: 'Account Role',
        pleaseSelect: 'Please select ',
        AccountChangeType: 'Account Change Type',
        AccountType: 'Account Type',
        currencyType: 'Currency Type',
        allType: 'All types',
        allAccount: 'All accounts',
        allCoin: 'All currencies',
        coin: "Currency",
        amount: 'Change Amount',
        balance: 'Balance',
        time: 'Time',
        title: 'Transaction History',
        filtrar: "Filtrar",
        check: "Switch to",
        showOnly: "Only show holdings",
        holdAssets: "Token balance",
        accountList: "Accounts"
    },
    contractTransaction: {

        chart: 'Chart',
        basicEdition: 'Original',
        depthMap: 'Depth',
        second: "S",
        minute: 'Min',
        day: 'Day',
        week: 'Week',
        month: 'Mon',
        open: 'Open',
        trade: 'Trade',
        buyLong: 'Buy Long',
        buyShort: 'Buy Short',
        cannotBuy: 'This currency does not support trading of delivery contracts',
        cannotBuy1: 'This currency does not support perpetual transactions',
        tradingAssets: 'Trading assets',
        amountAvailable: 'Available Amount',
        timeStr: 'Time',
        transactionPeriod: 'Transaction period',
        quantity: 'Amount',
        enterQuantity: 'Please enter  quantity',
        buyIn: 'Long',
        latestTransaction: 'Last trades',
        time: 'Time',
        direction: 'Direction',
        price: 'Price',
        sell: 'Short',
        positionOrder: 'Position order',
        historicalOrders: 'History',
        product: 'Product',
        realAccount: '(Real Account)',
        demoAccount: '(Demo Account)',
        openingTime: 'Open Position Time',
        openingPrice: 'Open Price',
        curretPrice: "Current Price",
        liquidationPrice: 'Close Price',
        profitOrLoss: 'Profit/Loss',
        endTime: 'Time to close position',
        areYouSureToBuy: 'Are you sure to buy?',
        areYouSureToLongBuy: 'Are you sure you want to buy more?',
        areYouSureToShortBuy: 'Are you sure you want to short buy?',
        successfullyBought: 'Successful purchase',
        minBuy: 'Minimum Buy',
        assets: 'Assets',
        withdraw: 'Withdraw',
        entrustedOrder: 'Entrusted order',
        total: 'Total',
        continueToPlaceOrder: 'Continue to place order',
        orderConfirmation: 'Order Confirmation',
        buyRu: 'Buy',
        sellChu: 'Sell',
        areYouSureToSell: 'Are you sure to sell?',
        operation: 'Action',
        buyCover: 'Covering positions',
        commitSuccess: 'Successful transaction',
        onlyEnterIntegers: 'Only integers can be entered',
        trend: "Trend",
        lotteryTime: "Order deadline",
        countdown: "Countdown",
        period: "Period",
        cycle: "Time Period",
        unlimited: "Unlimited",
        put: "PUT",
        call: "CALL",
        pending: "Pending",
        unopened: "Unopened",
        opened: "Opened",
        settlementPrice: "Closed price",
        rateOfReturn: "Rate of return",
        currentPositions: "Current",
        positionQuantity: "Position quantity",
        guarantee: "Margin",
        text1: "CALL",
        text2: "PUT",
        text3: "Waiting to buy",
        text4: "Order quantity",
        text5: "Transaction quantity",
        text6: "Cancel",
        text7: "Delivery time",
        text8: "Order Cancellation Reminder",
        text9: "Are you sure you want to cancel the order?",
        text10: "Illegal quantity",
        text11: "Order Reminder",
        text12: "Are you sure you want to buy?",
        text13: "Are you sure you want to buy the bearish position?",
        text14: "Order canceled successfully"
    },
    mining: {
        title1: "The world's leading BLOCKCHAIN MINING PLATFORM",
        title2: "Open and Transparent · Safe and Stable",
        title3: "Please select currency",
        title4: "Mining annualized rate of return",
        title5: "Day",
        title6: "Mining period",
        title7: "Product Details",
        btn: "Mine now",
        btn2: "Closure",
        tabs1: "In progress",
        tabs2: "Redeemed",
        table1: "Product name",
        table2: "Mining period",
        table3: "Mining time",
        table4: "Mining amount",
        table5: "Expire date",
        table6: "Yield to maturity",
        table7: "Order Status",
        egularMining: 'Regular mining',
        inProgress: 'In progress',
        redeemed: 'Redeemed',
        redemption: 'Redemption',
        regularMining: 'Regular mining',
        earlyRedemption: 'Early redemption',
        need: ' need ',
        handlingFee: 'Handling fee',
        redemptionConfirmationMessage: 'Please confirm whether to redeem in advance?',
        form1: 'Mining annualized rate of return',
        form2: 'Mining period',
        form3: 'Mining currency',
        form4: 'Subscription amount (minimum/maximum)',
        form5: 'Early redemption fee: ',
        form6: 'Purchasing price',
        form7: 'Available funds',
        form8: 'Purchasing price',
        form9: 'Available funds',
        form10: 'Please enter the purchase amount',
        form11: 'All',
        form12: 'Estimated income',
        form13: 'Insufficient funds available',
        form14: 'Please enter the purchase amount',
        form15: 'My Order',
        form16: 'Income',
        form17: 'Order details',
        form18: 'Early Redemption Notice:',
        form19: 'Subscription amount (minimum)',
        form20: 'Subscription amount (maximum)',
        form21: "Quantity held",
        form22: "Buy Time",
        form23: "Redemption time",
        form24: "Ended",
        form25: "Subscription successful",
        form26: "Redemption successful",
        form27: "Over 25% return, outperforming the market",
        form28: "Invite friends to get a reward of 50 USDT, and contract vouchers to return 20% commission."
    },
    assets: {
        content1: 'Assets',
        content2: "Today's PnL",
        content3: 'Current Account',
        content4: 'Real account is your actual account assets, can be used for trading, withdrawals',
        content5: 'Withdrawal',
        content6: 'Deposit',
        content7: 'Exchange',
        content8: 'Transfer',
        content9: 'Please select',
        content10: 'Demo Account',
        content11: 'Real Account',
        content12: 'Get assets',
        content13: 'Are you sure you want to switch to a Real account? ',
        content14: 'Are you sure you want to switch to a demo account? ',
        content15: 'Get Success',
        tabs1: 'Exchange',
        tabs2: 'Trade',
        tabs3: 'Mining',
        tabs4: 'Margin',
        table1: 'Currency',
        table2: 'Quantity',
        table3: 'Freeze',
        table4: 'Available',
        dialog1: 'Product Details',
        dialog2: '1、The asset is only allowed to be used in demo account mode',
        dialog3: '2、In order to prevent abuse, you are only allowed to receive the assets once in a month',
        dialog4: '3、Receiving the asset will add the amount of the asset on the original basis and will not change the position status',
        dialog5: '4、If you have other questions, please contact customer service',
        dialog6: 'Close',
        dialog7: 'Get Demo Assets Now',
        dialog8: 'Transfer in',
        dialog9: 'Transfer out',
        dialog10: 'Toggle',
        dialog11: 'Valuation',
        dialog12: 'Demo assets',
        dialog13: 'My account',
        dialog14: 'Total Assets',
        dialog15: 'Overview',
        dialog16: "Total asset valuation",
        dialog17: "Asset Valuation",
        dialog18: "Today's earnings",
        dialog19: "Freeze funds",
        dialog20: "You can receive simulated asset quota every month",
        dialog21: "Receive",
        dialog22: "You have received successfully",
        dialog23: '30-day accumulated income',
        dialog24: "Financial Management Products",
        dialog25: "My Financial Management",
        dialog26: "Historical Financial Management",
        dialog27: "History",
        dialog28: "Fund Records"
    },
    validator: {
        dialog14: 'Validator',
        dialog15: 'Binding validator',
        dialog16: 'Validator switch',
        dialog17: 'Verification code',
        dialog18: 'Authenticator QR code',
        dialog19: 'Authenticator key',
        dialog20: 'Save',
        dialog21: 'Please select a validator',
        dialog22: 'Copy key',
        dialog23: 'Successfully saved',
        dialog24: 'Please enter verification code',
        dialog25: 'Friendly reminder: Please open the corresponding APP and scan the QR code below or manually add the key before confirming the save!',
        dialog26: 'Activate your authenticator to provide maximum security for your account.',
        dialog27: 'Every time you log in or withdraw money, you will need to enter a unique verification code that is accessed via your mobile phone.',
        dialog28: 'Set up validator',
        dialog29: 'Help',
        dialog30: 'You have not bound an authentication code. Get stronger protection with authenticators.',
        dialog31: 'Authenticator has not been set yet, please set it first',
        dialog32: 'Go to settings'
    },
    recharge: {
        title1: "Don't know how to use digital currency to buy?",
        title2: "Only three simple steps!",
        title3: "Select the digital currency you need to purchase from the drop-down menu, and then enter the purchase quantity or amount.",
        title4: "Choose your preferred payment method",
        title5: "After confirming the payment, the digital currency you purchased will be automatically transferred to your account.",
        title6: "Please select the currency you want to Deposit",
        title7: "Deposit Record",
        table1: "Currency",
        table2: "Quantity",
        table3: "Chain name",
        table4: "Status",
        table5: "Reason",
        table6: "Time",
        table7: "View Vouchers",
        dialog1: "Please enter the code below",
        dialog2: "Payment Code",
        dialog3: "Copy",
        dialog4: "Address",
        dialog5: "Deposit amount",
        dialog6: "Transaction screenshot",
        dialog7: "Important notice",
        dialog8: 'Please fill in the amount of coin charged',
        dialog9: 'Upload image',
        dialog10: 'Please enter the amount',
        dialog11: 'Please upload a screenshot of your top-up',
        dialog12: 'pending',
        dialog13: 'Rejected',
        dialog14: 'success',
        tip1: 'Submitted successfully',
        tip2: "Copy Success",
        tip3: 'Copy failed',
        tip4: "Please select the currency you want to Deposit",
        tip5: "1. The above coin-filling address is the official receiving address of the platform, please recognize the official coin-filling address of the platform, and bear the loss of funds caused by misfilling.",
        tip6: "2. Please be sure to confirm the security of your computer and browser to prevent the information from being tampered with or leaked.",
        tip7: "3. After you recharge the above address, you need the confirmation of the whole network node before you can arrive at the account.",
        tip8: "4. Please select the above token system and coins and transfer the corresponding amount for coin charging, please do not transfer any other irrelevant assets, otherwise it will not be retrievable.",
        tip9: 'Save the QR code',
        tip10: 'Recharge',
        tip11: 'Important Notice',
        tip12: 'Offsite link',
        tip13: 'Recharge QR code',
        tip14: 'Next step',
        tip15: 'Recharge record',
        tip16: 'Recharge Details',
        tip17: 'Deposit address',
        tip18: 'Quick Payment',
        tip20: 'Insufficient balance',
        tip22: 'Submitted, waiting for confirmation',
        tip23: 'Waiting for payment',
        tip24: 'Amount',
        tip25: 'Payment has been submitted, waiting for block confirmation',
        tip26: 'Payment Declined',
        tip27: 'Payment Fail',
        tip28: 'Successful Payment',
        bankChannel: 'Bank Card Channel',
        tip29: "History search",
        tip30: "Currency list",
        tip31: "Select network",
        tip32: "When you recharge this currency, please only recharge through the supported networks below. If you recharge through other networks, funds will be lost.",
        tip33: "When you withdraw this currency, please only withdraw through the supported networks below. If you withdraw through other networks, funds will be lost.",
        tip34: "Quick recharge",
        tip35: "Scan QR code to recharge",
        tip36: "Manual recharge",
        tip37: "Network",
        tip38: "Address",
        tip39: "Amount",
        tip40: "Upload transaction receipt",
        tip41: "Upload pictures",
        tip42: "Confirm submission",
        tip43: "Confirm payment",
        tip44: "Remarks: Please confirm the address you need to recharge. We are not responsible for the loss of money if you fill it in incorrectly",
        tip45: "Reminder",
        tip46: "Address copy successful!",
        tip47: "Address copy failed!",
        tip48: "Insufficient available balance",
        tip49: "Submit recharge successfully, waiting for confirmation on the chain",
        tip50: "Failed",
        tip51: "The recharge amount is wrong",
        tip52: "Connection failed",
        tip53: "Wallet is not logged in",
        tip54: "Connection refused",
        tip55: "Submission successful, waiting for customer service review and approval",
        tip56: "Please upload a screenshot of the transaction receipt",
        tip57: "Submission failed",
        tip58: "Recharge Record",
        tip59: "Withdrawal Record",
        tip60: "Symbol",
        tip61: "Symbol",
        tip62: "Address",
        tip63: "Screenshot display",
        tip64: "Click to enlarge the image",
        tip65: "Time",
        tip66: "Reason for rejection",
        tip67: "Amount",
        tip68: "Amount received",
        tip69: "Network",
        tip70: "Address",
        tip71: "Time",
        tip72: "Close",
        tip73: "Transaction screenshot",
        tip74: "To be reviewed",
        tip75: "Rejected",
        tip76: "Completed",
        tip77: "Rejected",
        tip78: "Has been reviewed",
        tip79: "Withdrawal",
        tip80: "Extract",
        tip81: "Transfer network",
        tip82: "Address/Invoice",
        tip83: "Withdraw all",
        tip84: "Do not withdraw money directly to the crowdfunding or ICO address, otherwise you will not be able to receive the tokens issued by the crowdfunding or ICO",
        tip85: "Amount received",
        tip86: "Confirm",
        tip87: "Wrong withdrawal address",
        tip88: "Withdrawal amount is wrong",
        tip89: "Withdrawal amount is at least",
        tip90: "The maximum withdrawal amount is",
        tip91: "Withdrawal request has been submitted",
        tip92: "Address list",
        tip93: "You have not added an address yet",
        tip94: "Add now",
        tip95: "Add address",
        tip96: "Add new address",
        tip97: "Please select",
        tip98: "Address",
        tip99: "Please select a transfer network",
        tip100: "Please enter the address",
        tip101: "Address added successfully",
        tip102: "Progress"
    },
    fundExchange: {
        title1: 'How to exchange funds?',
        title2: 'Select the corresponding currency that needs to be "from" to exchange.',
        title3: 'Select the corresponding currency to be exchanged.',
        title4: 'Enter the number of exchanges and click Submit to complete the exchange of funds.',
        title5: 'From',
        title6: 'To',
        title7: 'Exchange Qunantity',
        title8: 'Exchange rate',
        title9: 'Available',
        title10: "Enter the quantity to be redeemed",
        title11: 'No corresponding pairs can be exchanged',
        title12: 'Please enter quantity',
        title13: 'Redeemed successfully',
        title14: 'Exchange details',
        table1: 'Use currency',
        table2: 'Quantity',
        table3: 'Exchange rate',
        table4: 'Exchange currency',
        table5: 'Arrive',
        table6: 'Time',
        title15: "F",
        title16: "There are currently no assets available, please choose another"
    },
    fundTransfer: {
        title1: 'How to transfer funds?',
        title2: 'Select the current fund account that needs to be transferred.',
        title3: 'Select the fund account to be transferred.',
        title4: 'Enter the transfer amount and click Submit to complete the transfer.',
        title5: 'Crypto',
        title6: 'Amount of transfers',
        title7: 'Please enter the transferred',
        title8: 'Transfer History',
        title9: 'Please select wallet type',
        title10: 'Please select a currency',
        title11: 'Please select wallet type',
        title12: 'Please select a currency',
        title13: 'Please enter the amount to be transferred',
        title14: 'Submitted successfully',
        table1: 'Transfer out account',
        table2: 'Transfer currency',
        table3: 'Number of transfers',
        table4: 'Transfer to account',
        table5: 'Time',
        table6: 'Transfer',
        table7: 'Fund Transfer',
        table8: 'Transfer to',
        table9: 'Transfer Record',
        table10: 'Transfer details',
        table11: "Transfer successful",
        table12: "Transfer failed",
        table13: "Current account cannot be transferred"
    },
    withdrawal: {
        title1: 'Important notice',
        title2: '1. In order to prevent cashing out, you can apply for coin withdrawal when the transaction volume reaches the quota.',
        title3: '2. The funds will be available within 24H after the withdrawal application is submitted. If the funds are not available after the estimated withdrawal time, please consult the online customer service.',
        title4: '3. After submitting the withdrawal application, the funds are frozen because the withdrawal is in progress and the funds are temporarily hosted by the system, which does not mean you have lost the assets or the assets are abnormal.',
        title5: 'Currency',
        title6: 'Wallet address',
        title7: 'Withdrawal amount',
        title8: 'Withdrawal record',
        title9: 'Please select a currency',
        title10: 'Please select the chain type',
        title101: '',
        title11: 'please enter ',
        title12: ' wallet address',
        title13: 'Submitted successfully',
        title14: 'Under Audit',
        title15: 'Successful audit',
        title16: 'Failed to verify',
        title17: 'Paid',
        title18: 'Please enter wallet address',
        title19: 'Enter amount',
        title20: 'Handling fee',
        title21: 'Actual Amount',
        table1: 'Currency',
        table2: 'Withdrawal amount',
        table3: 'Chain name',
        table4: 'Wallet address',
        table5: 'Status',
        table6: 'Reason',
        table7: 'Apply time',
        table8: 'Withdraw',
        table81: ' coin withdrawal',
        table9: 'Withdrawal address',
        table10: 'Please select the currency you want to withdraw',
        table11: 'Please make sure you enter',
        table12: 'Address (usually starts with "0x")',
        table13: 'Coins can be withdrawn (after deduction of handling fee):',
        table14: 'Select currency',
        table15: 'Encounter problems? feedback immediately',
        table16: 'Balance',
        table17: 'Withdrawal details',
        password: 'Password',
        passwordTips: 'Please enter password',
        passwordAg: 'Confirm Password',
        passwordAgTips: 'Please enter password again',
        oldPassword: 'Old Password',
        oldPasswordTips: 'Please enter old password',
        newPassword: 'New password',
        newPasswordTips: 'Please enter a new password',
        passwordNotSame: 'Passwords do not match',
        withdrawPasswordSet: 'Set withdrawal password',
        withdrawPasswordModify: 'Modify withdrawal password',
        withdrawPassword: 'Withdraw password',
        withdrawPasswordTips: 'Please enter the withdrawal password',
        setWithdrawPasswordFirst: 'Please set the withdrawal password first',
        withdrawPasswordSetSuccess: 'Successfully set',
        withdrawPasswordModifySuccess: 'Successfully modified',
        submit: 'Submit',
    },
    customer: {
        content1: 'Contact Us',
        //content2: 'Online Customer Service',
        content2: 'Contact Us',
        content3: 'Please Enter your name',
        content4: 'Please enter message',
        content5: 'Send',
        content6: 'Send failed, network connection failed',
        content7: "Picture",
        content8: "The message is empty",
        content9: "My sharing",
        content10: "Share link",
        content11: "Save image",
        content12: "My earnings",
        content13: "Level description",
        content14: "Team size",
        content15: "Invitation benefits",
        content16: "Share Instructions",
        content17: "Member level",
        content18: "The recharge amount is greater than",
        content19: "Team level",
        content20: "Team Level & Income",
        content21: "Meet the conditions",
        content22: "Distribution income",
        content23: "Super team",
        content24: "Level, invitation",
        content25: "valid members",
        content26: "First-level income",
        content27: "Secondary income",
        content28: "Third-level income",
    },
    standardContract: {
        increaseMargin: "Increase margin",
        increaseAmount: "Increase amount",
        Pleaseenterthemargin: "Please enter the margin amount to be increased",
        Pleaseenterthecorrect: "Please enter the correct deposit amount",
        Increasemarginsuccessfully: "Increase margin successfully",
        takeProfitPriceWrong: "Wrong take profit price",
        stoppriceerror: "Stop price error",
        thetakeprofit1: "The take profit price must be higher than the market price",
        thetakeprofit2: "Stop loss price must be lower than market price",
        thetakeprofit3: "The take profit price must be lower than the market price",
        thetakeprofit4: "Stop loss price must be higher than market price",
        thetakeprofit5: "Wrong quantity",
        estimatedprofitloss: "Estimated profit and loss",
        positionAmount: "Number of positions",
        closeAmount: "Closing quantity",
        whenthelatest: "When the latest price is reached ",
        whenthelatest2: "The market price take profit order will be triggered to close the current position. Expected profit and loss ",
        whenthelatest3: "The market stop loss order will be triggered to close the current position. Expected profit and loss",
        contract: "Contract",
        ordercanceledsuccessfully: "Order canceled successfully",
        successfullyordered: "Successfully ordered",
        positionopeningreminder: "Position reminder",
        wrongquantity: "Wrong quantity",
        quantitycannot: "The quantity cannot be greater than ",
        modificationstoploss: "Modification of stop profit and stop loss successful",
        positionclosedsuccessfully: "Position closed successfully",
        orderCancellation: "Cancel",
        orderCancellation2: "Are you sure you want to cancel the order?",
        contractTransaction: 'Contract Transaction',
        tobeexecuted: "To be executed",
        expired: "Expired",
        failed: "Failed",
        increase: 'Increase',
        openPosition: 'Open Position',
        isolatedPosition: "Isolated position",
        limitOrder: 'Limit',
        marketOrder: 'Market',
        pleaseSelectLeverage: 'Please select leverage',
        pleaseEnterQuantity: 'Enter quantity',
        canOpenMore: 'Maximum Positions',
        contractAmount: 'Contract amount',
        openingFee: 'Handling fee',
        currentPosition: 'Positions',
        historicalPositions: 'Trades',
        currentCommission: 'Orders',
        historicalCommission: 'History',
        buyPrice: 'Entry price',
        income: 'Profit',
        quantity: 'Quantity',
        marginRate: 'Margin ratio',
        initialMargin: 'Margin',
        estimatedPriceParity: 'Est. liq. Price',
        operate: 'Operate',
        finishQuantity: 'Finish Quantity',
        averagePrice: 'Entry price',
        pleaseEnterLeverage: 'Please enter leverage',
        takeProfitAndStopLoss: 'TP/SL',
        takeProfit: "Take profit",
        stopLoss: "Stop loss",
        openLong: "Long",
        openShort: "Short",
        liquidation: 'Close',
        marketLquidation: 'Close all',
        cancel: 'Cancel',
        enterBuyPrice: 'Please enter buying price',
        areYouSureLquidation: 'Are you sure liquidation?',
        confirm: "Confirm",
        enterStopWinPrice: 'TP trigger price',
        enterStopLossPrice: 'SL trigger price',
        commissionTime: 'Commission Time',
        commissionPrice: 'Consigment Price',
        commissionQuantity: 'Consigment QTY',
        volumeAlreadyTraded: 'Volume Already Traded',
        areYouSureToWinOrLoss: 'Are you sure to win or loss?',
        maxQuantity: "Max Quantity",
        saleQuantity: "Quantity",
        salePrice: 'Closeout Price',
        saleTime: "Time",
        succeeded: "Succeeded",
        cancelled: 'Cancelled',
        piece: 'Pieces',
        triggerPrice: 'Trigger Price',
        setWin: 'Take profit',
        setLoss: 'Stop loss',
        enterWinQuantity: 'Enter stop win quantity',
        enterLossQuantity: 'Enter stop loss quantity',
        planCommission: 'Plan',
        enterWinTriggerPrice: 'Enter win trigger price',
        enterLossTriggerPrice: 'Enter loss trigger price',
        insufficientQuantity: 'Insufficient quantity',
        enterTriggerPrice: 'Enter trigger price',
        tips1: 'Is your mandate price higher than the current market price and do you buy directly at the current market price?',
        tips2: 'Is your mandate price lower than the current market price and do you buy directly at the current market price?',
        type: 'Type',
        increaseQuantity: 'Increase quantity',
        reduceQuantity: 'Reduce quantity',
        limitCommission: 'Limit commission',
        tips3: 'The price of the stop loss must be lower than the market price',
        tips4: 'The price of the take profit must be higher than the market price',
        tips5: 'The price of the stop loss must be higher than the market price',
        tips6: 'The take profit price must be lower than the market price',
        tips7: 'The stop loss price should be less than the market price and less than the order price',
        tips8: 'The take profit price is greater than the order price (it can be smaller than the market price)',
        tips9: 'The stop loss price should be greater than the market price and greater than the order price',
        tips10: 'The take profit price should be less than the order price (it can be larger than the market price)',
        accountEquity: 'Account Balance',
        unrealizedPL: 'Unrealized P&L',
        tips11: 'Are you sure',
        tips12: 'at market price',
        tips13: 'close all positions',
        tips14: 'Do not remind again',
        profitRate: 'Closeout Yield',
        openTime: 'Opening time',
        unwindTime: 'Closeout time',
        dealTime: 'Transaction Time',
        amountClose: 'Amount closed',
        long: "Long",
        short: 'Short',
        orderQuantity: "Amount",
        entrustedMargin: "Margin"
    },
    spotGoods: {
        spotGoods: 'Convert',
        sellPrice: 'Sell price',
        orderRecord: 'Convert record',
        transactionTime: 'Transaction time',
        maxBuy: 'Max buy',
        maxSell: 'Max sell',
        purchaseQuantity: 'Purchase quantity',
        slippage: "Slippage",
        convertTips: "We will trade at the best price with a slippage of 0-5%.",
        changePrice: "Current exchange price",
        consume: "Consume",
        get: "Get",
        changeTips: "Are you sure you want to exchange it?",
        confirm: "Confirm"
    },
    news: {
        title: 'News Center',
        redMore: 'Read more',
    },
    credit: {
        credit: 'Credit Score',
        creditScore: 'Total Credit Score',
        latestEntry: 'Latest Record',
        liveUpdate: 'Real-time updates',
        systemEvaluation: 'System evaluation',
        time: 'Date',
        name: 'Name',
        reason: 'Reason',
        scoreStory: 'Credit score'
    },
    borrowing: {
        borrowing: 'Loan',
        diversifiedMarket: 'Diversified Market',
        totalSupply: 'Total Supply',
        totalBorrowings: 'Total Loan',
        tips1: 'This is the total amount you can borrow, and you can borrow based on your collateral until the borrowing limit is reached.',
        tips2: 'The stable interest rate will remain the same for the duration of your loan. Recommended for long term supply and users who like predictability.',
        totalSupplys: 'Total Supply',
        supplyAPR: 'Supply Rate',
        totalBorrowings: 'Total borrowings',
        borrowAPR: 'Borrow Rate',
        check: 'View',
        market: 'Market',
        availableLiquidity: 'Available Liquidity',
        currencyPrice: 'Current currency price',
        supplyAssets: 'Supply Assets',
        tips3: 'Note: The interest rate below is a fixed rate and the principal plus interest will be returned to your account at the end of the supply cycle.',
        supplyCycle: 'Supply Cycle',
        minimumSupply: 'Minimum Supply',
        supply: 'Supply',
        borrowedAssets: 'Borrowed Assets',
        tips4: 'Note: To borrow money, you will need to provide any collateral assets or proof.',
        tips5: 'Please see the description of collateral assets.',
        repaymentCycle: 'Repayment Period',
        BorrowableAmount: 'Borrowing Amount',
        borrow: 'Borrowing',
        accountInformation: 'Account Information',
        walletBalance: 'Wallet Balance',
        canSupply: 'Available',
        AmountCanBeBorrowed: 'Borrowable amount',
        borrowedAmount: 'Borrowed Amount',
        remainingAmount: 'Remaining Amount',
        getBorrowednAmount: 'Get Loan Amount',
        supplyOrder: 'Supply Order',
        borrowedOrder: 'Loan Order',
        supplyAmount: 'Supply Amount',
        expectedProfits: 'Expected Profits',
        supplyTime: 'Supply Time',
        expirationTime: 'Expire Date',
        borrowingAmount: 'Loan Amount',
        dueRepayment: 'Repayment amount',
        borrowingTime: 'Release Time',
        repaymentTime: 'Repayment Time',
        repay: 'Repayment',
        supplyCurrency: 'Supply Currency',
        buyNow: 'Buy Now',
        supplyRecords: 'Supply Records',
        borrowRecords: 'Loan Records',
        completed: 'Completed',
        borrowNow: 'Borrow Now',
        borrowCurrency: 'Loan Currency',
        borrowMin: 'Min',
        borrowMax: 'Max',
        borrowRange: 'Loan amount (min/max)',
        tips6: 'Please repay in time. If it is overdue, an additional amount of (principal + interest) will be charged every day ',
        tips7: ' for overdue fees.',
        pleaseEnterBorrowAmount: 'Please enter loan amount',
        interest: 'Interest',
        tips8: 'Are you sure you want to repay in advance?',
        borrowChannel: 'Borrowing channel',
        tips9: "Let's start by getting to know you",
        name: 'First Name',
        lastName: 'Last Name',
        birthDate: 'Date of Birth',
        tips10: "A little more info, what's your address?",
        familyAddress: 'Home address (including unit number)',
        city: 'City',
        country: 'Nationality',
        postalCode: 'Postal code',
        pleaseEnterYourHomeAddress: 'Please enter your home address',
        tips11: 'Tell us your financial situation',
        tips12: 'We may need to confirm this information later, so please try to be as accurate as possible',
        yourMonthlyIncome: 'Your monthly income',
        enterYourMonthlyIncome: 'Please enter your monthly income',
        extraIncomeOptional: 'Additional income (optional)',
        enterExtraIncome: 'Please enter your additional income',
        monthlyRentOrMortgagePayment: 'Monthly rent or mortgage payment',
        enterMonthlyRent: 'Please enter your monthly rent or mortgage payment',
        tip13: 'Tell us if you have a mortgage',
        tip14: 'If no mortgage guarantee is selected, the probability of passing the review is low',
        isThereMortgage: 'Is there a mortgage',
        selectIsThereMortgage: 'Please choose whether there is a mortgage',
        selectMortgageType: 'Please select the mortgage type',
        yes: 'Yes',
        no: 'No',
        uploadScreenshotOfTransaction: 'Please upload a screenshot of the transaction',
        tip15: 'Let us keep in touch',
        tip16: 'If we need more information about your loan application, we may contact you through this number',
        tip17: 'I have read and agree by electronic signature ',
        tip18: 'Terms of Use and Electronic Consent ',
        tip19: '，This includes your consent to us sending you information about us ',
        tip20: 'Product and Service Terms of Use',
        tip21: 'After filling in the information, please wait for the system evaluation and review.',
        phoneNumber: 'Phone number',
        enterPhoneNumber: 'Please enter your phone number',
        tip22: 'Please check Agree to the terms of use and electronic consent form',
        inReview: 'Under review',
        applicationAmount: 'Approval Amount',
        reasonForRejection: 'Reason for refusal',
        reapply: 'Re-apply',
        applyStatus: 'Application Status',
        currentOrder: 'Current order',
        interestRate: 'Interest Rate'
    },
    yuebao: {
        filed1: 'Put In',
        filed2: 'Take Out',
        filed3: 'Daily Income',
        filed4: 'Team Acceleration',
        filed5: 'Has Been Deposited',
        filed6: "Yesterday's Earnings",
        filed7: 'Total Revenue',
        filed8: 'Available Funds',
        filed9: 'Please enter the amount',
        filed10: "Liquidity Mining",
        filed11: 'Introduction',
        field12: "Minimum buyable",
        field13: "Maximum purchase",
        filed14: "Buy",
        filed15: 'regular',
        filed16: 'APR',
    },
    tipsPopover: {
        title: 'Install this application',
        press: 'Press',
        and: 'and',
        scrren: 'Add to home screen',
        hasInstall: "(If already installed, close the window)",
    },
    follow: {
        title1: "Copy trading",
        follow_text1: "Initiate follow",
        follow_text2: "Release history",
        follow_text3: "Title",
        follow_text4: 'Trading pair',
        follow_text5: 'Purchase duration',
        follow_text6: 'Order time',
        follow_text7: 'Release time',
        follow_text8: 'Number of followers',
        follow_text9: 'Order amount',
        follow_text10: 'Operate',
        follow_text11: 'Invite',
        follow_text12: 'Follow the order direction',
        follow_text13: 'Follow the order direction',
        follow_text14: 'Conditions for following orders',
        follow_text15: 'Fixed amount',
        follow_text16: 'Percentage',
        follow_text17: 'Invited people',
        follow_text18: 'The other party’s ID',
        follow_text19: "Confirm to follow the order",
        follow_text20: "Your order amount (optional)",
        follow_text21: "Please enter a title",
        follow_text22: "Please select a trading pair",
        follow_text23: "Please select the order direction",
        follow_text24: "Please select purchase duration",
        follow_text25: "Please select the order time",
        follow_text26: "Please select purchase quantity",
        follow_text27: "The maximum purchase quantity cannot be less than the minimum purchase quantity",
        follow_text28: "Minimum buy-in",
        follow_text29: "Most buy",
        follow_text30: "Create copy order successfully",
        follow_text31: "Trading pair list",
        follow_text32: "Already followed the order",
        follow_text33: "Please enter invitee information",
        follow_text34: "Invited",
        follow_text35: "Invited me",
        follow_text36: "Copying history",
        follow_text37: "Order amount range ",
        follow_text38:"Please enter the order code"
    },
    followHistory: {
        title1: 'Release history',
        title2: "Copying history",
        follow_h_text1: "The total amount of the order",
        follow_h_text2: "Total number of people following orders",
        follow_h_text3: "Number of releases",
        follow_h_text4: "winning rate",
        follow_h_text5: "Number of times to follow orders",
        follow_h_text6: "Profit from following orders",
        follow_h_text7: "Direction",
        follow_h_text8: "Win",
        follow_h_text9: "Deficit",
    },
    "download.description.C80C1Edd6Bee12Bc": "1.Allow description files to be downloaded",
    "download.description.2F5Bc180F92642B4": "2.Description file downloaded",
    "download.description.3C3B849F6Ccf712F": "3.Enter [Settings] on your phone and the downloaded description file will be displayed below the account information.",
    "download.description.86Affd862985E045": "4.Click to download the description file",
    "download.description.32832492Bfc1D95E": "5.Click to install",
    "home.index.04Ee893775563F25": "Waiting for result",
    "home.index.04Ee893775563F26": "Waiting for result",
    "passwod.limit":"Password length must be greater than or equal to 6 characters",
    "finance.header.E5Dd9Bbdab4F52D2": "Help You Invest",
    "finance.header.5Cbf11665B91D51D": "Balance Addition",
    "finance.index2.B1A4Be8079A937F8": "Purchase Amount Range",
    "finance.index2.8371E53029Dc7558": "Penalty Fee",
    "finance.index2.Bf9A2C9Bf7Ecaf04": "Loanable ratio",
    "finance.index2.2Ad78Bbd879C4990": "Buy Now",
    "finance.index2.A3B7445Ea9D7E111": "Not Available for Purchase",
    "finance.index2.A3B7445Ea9D7E112": "Available for Purchase",
    "finance.index2.87701Fe9Ad8540Dc": "Total Purchaseable Amount/Purchased Amount",
    "finance.index2.652Effdf5D1Af6A2": "Expected Return Rate",
    "finance.index2.D3C3C19De952Fc0C": "Purchase Date",
    "finance.index2.6C4C46Cc4Da0C281": "Current Amount",
    "finance.index2.3E9A6703Abd8A3E4": "Yesterday's Earnings",
    "finance.index2.596704E9869C8134": "Total Earnings",
    "finance.index2.0A845B549624B74B": "Annualized Yield",
    "finance.index2.9A7758Cad0402366": "Current Holdings",
    "finance.index2.9A7758Cad0402367": "Earnings Record",
    "finance.index2.8B8Ceb7610C747Eb": "Historical Record",
    "finance.index2.8B8Ceb7610C747Ec": "Investment Record",
    "finance.index2.0B049108D57B9Dd5": "Withdraw Early",
    "finance.index2.37Ffde1Ee1D3C8D4": "Withdrawn Early",
    "finance.index2.12F6B830Aee90Efb": "Matured",
    "finance.index2.40E1944D8Cafbdad": "Holding Amount",
    "finance.index2.9815C4F248B624F5": "Purchase Date",
    "finance.index2.46F7Be1133B3E2C6": "End Date",
    "finance.index2.Fc8643Aa7Babcce8": "Earnings",
    "finance.index2.1F2B02E97721B997": "Withdrawn Early?",
    "finance.index2.14E543A74595Efe8": "Pending",
    "finance.index2.14E543A74595Efe9": "In Progress",
    "finance.index2.14E543A74595Efe0": "Completed",
    "finance.index2.8E29Fbba37286B63": "Advisor Name",
    "finance.index2.D736C17Df71Bcdb2": "Application Amount",
    "finance.index2.F38884Ed4410D9F6": "Successfully Applied Amount",
    "finance.index2.E3347Eb6F76Eda1C": "Earnings Received",
    "finance.index2.0Fc0070Cb4E9F5A8": "Investment Time",
    "finance.index2.8Efd11Be6D9F43Df": "Start of Earnings Time",
    "finance.index2.16658A855F07D171": "Amount",
    "finance.index2.184333C81Babf2F1": "Type",
    "finance.index2.15Cba911299D4Afd": "Buy Now",
    "finance.index2.Da1Cdb155Ae381Cd": "Withdrawal Amount",
    "finance.index2.15Efec8F145F2608": "Current Amount (USDT): ",
    "finance.index2.159253C05C270D46": "Holding Amount (USDT): ",
    "finance.index2.Caab3A4Ba941E0E3": "Early Withdrawal Fee (USDT): ",
    "finance.index2.Fb5Fc50Cf3716723": "Purchasable",
    "finance.index2.5Dcb4Ee5C7F1F4E1": "Enter Amount",
    "finance.index2.5886C88906Cc4491": "All-Star Advisor Team, Taking Care of Every Penny You Have",
    "finance.index2.5886C88906Cc4492": "Principal and Interest Guaranteed, Flexible Withdrawals, Earn in Market Fluctuations",
    "finance.index2.F5Af24Dbad5837Ea": "Redemption Successful",
    "finance.index2.Be15Df7F1D76F9B2": "Investment Amount",
    "finance.index2.Fc57951B528F3Dd3": "Available for Lending",
    "finance.index2.3F91F76109Fdbdeb": "Already Lent Out",
    "finance.index2.F68600F93Fe31213": "Lend Out",
    "finance.index2.494E47D4025Da8E6": "Repayment",
    "finance.index2.27F6657Ebf2025E3": "Lending Amount",
    "finance.index2.27F6657Ebf2025E4": "Repayment Amount",
    "finance.index2.631Fc4Ce8Aeee66F": "Confirm Lending",
    "finance.index2.631Fc4Ce8Aeee66G": "Confirm Repayment",
    "time.text1":"Start Date",
    "finance.index2.631Fc4Ce8Aeee66H": "To be confirmed",
}